import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface SidebarState {
  collapsed: boolean
  toggleCollapse: () => void
  setCollapsed: (collapsed: boolean) => void
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set, get) => ({
      collapsed: false,

      toggleCollapse: () => {
        set({ collapsed: !get().collapsed })
      },

      setCollapsed: (collapsed: boolean) => {
        set({ collapsed })
      },
    }),
    {
      name: 'sidebar-storage',
    }
  )
)
